// Path: /home/ladmin/ESTATA/apps/0001-estata.com/frontend/src/components/HeroBanner.tsx
// Version: v1.1.0
// Beschreibung: Hero Banner Komponente mit flexiblen Props

import Container from "../hooks/Container.tsx";
import Button from "./ui/Button.tsx";

interface HeroBannerProps {
  image: string;
  department?: string;
  header?: string;
  welcome?: string;
  subtitle?: string;
  title: string;
  description: string;
  buttonText: string;
  buttonLink: string;
}

const HeroBanner = ({
  image,
  department,
  header,
  welcome,
  subtitle,
  title,
  description,
  buttonText,
  buttonLink,
}: HeroBannerProps) => {
  // Nutze department oder subtitle als Überschrift
  const topText = department || subtitle || welcome || "";
  // Nutze header oder title als Haupttitel
  const mainTitle = header || title;

  return (
    <div 
      className="text-white relative h-[calc(100vh-100px)] w-full mb-[100px] md:mb-[150px] lg:mb-[300px]"
      style={{
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center">
        <Container className="text-left md:text-left lg:text-left font-semibold max-w-[1000px]">
          {topText && (
            <div className="text-lg md:text-xl lg:text-2xl mb-5">
              {topText}
            </div>
          )}
          <div className="text-4xl md:text-4xl lg:text-6xl font-bold mb-5">
            {mainTitle}
          </div>
          <div className="text-lg md:text-xl lg:text-2xl mb-5">
            {description}
          </div>
          <Button to={buttonLink} variant="bordered" size="M">
            {buttonText}
          </Button>
        </Container>
      </div>
    </div>
  );
};

export default HeroBanner;
